import { Box } from "@mui/material";
import React, {  useState } from "react";

// call page


import { Navigate } from "react-router-dom";


import BillOfMaterialMenu from "../features/billofmaterial/Menu";
import BillOfMaterial from "../features/billofmaterial/bom/BillOfMaterial";
import BillOfMaterialSummary from "../features/billofmaterial/summary/BOMSummary";
import BillOfMaterialPlanSummary from "../features/billofmaterial/plan/PlanSummary";
import CostingModule from "../features/costing/CostingView";


const BillOfMaterialIndex = () => {

    const [activePage, setActivePage] = useState('ViewMainPage');
   

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }


    return (


        <Box position="relative">

            {activePage === "ViewMainPage" && (<BillOfMaterialMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />
            )}           

            
            {activePage === "billofmaterialmaster" && (
                <BillOfMaterial handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "billofmaterial" && (
                <BillOfMaterialSummary handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}           

            {activePage === "billofmaterialplan" && (
                <BillOfMaterialPlanSummary handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "costing" && (
                <CostingModule />
            )}

            


        </Box>
    );
};
export default BillOfMaterialIndex;